import React from "react";
import Space from "../../commons/Space";
import TitoloSezioni from "../../commons/TitoloSezioni";

function FitnessInfoCorsi() {
    return(
        <div className="info-corsi" id="infoFitness">
            <Space />
            <br/>
            <dl className="row" style={{marginLeft: "2em", maxWidth: "100%"}}>

                <dt className="col-sm-3">Stretching Pilates / Postural Pilates</dt>
                <dd className="col-sm-9 mb-4">
                    Attività adatta a tutte le età, finalizzata al riequilibrio corporeo e al
                    miglioramento della postura,
                    <br/> attraverso esercizi di respirazione, allungamento,
                    rinforzo e resistenza muscolare.
                </dd>

                <dt className="col-sm-3">Pilates</dt>
                <dd className="col-sm-9 mb-4">
                    Il Pilates è un metodo di allenamento che migliora forza, flessibilità e postura
                    attraverso movimenti controllati e consapevoli.
                    <br/>Si concentra su respirazione, core e allineamento del corpo.
                </dd>

                <dt className="col-sm-3">Total Body / Up Body / Leg Crash</dt>
                <dd className="col-sm-9 mb-4">
                    Allenamento completo con focus su parte superiore, inferiore e total body.<br/>
                    Un mix di esercizi funzionali, dinamici e di forza per tonificare e migliorare
                    resistenza ed equilibrio.
                </dd>


                <dt className="col-sm-3">Dance Workout</dt>
                <dd className="col-sm-9 mb-4">
                    Un mix travolgente di danza e fitness per allenarti divertendoti.
                    <br/>Brucia calorie, tonifica il corpo e libera la tua energia a ritmo di musica.
                </dd>


                <dt className="col-sm-3">Hataha Yoga</dt>
                <dd className="col-sm-9 mb-4">
                    Letteralmente sole e luna che rappresentano anima e coscienza
                    <br/> Conosciuto anche come Yoga della forza, è bastato sull'esecuzione di posizioni e tecniche di respirazione
                    <br/> Apporta benefici sia a livello fisico che mentale prevenendo dolori muscolari e alleviando stress, ansia e disturbi depressivi
                </dd>

                <dt className="col-sm-3">Functional Training / GAG</dt>
                <dd className="col-sm-9 mb-4">
                    Allenamento finalizzato a migliorare il movimento dell'intero corpo e non del singolo distretto muscolare
                    <br/> Stimola mobilità, velocità, forza, resistenza e coordinazione
                </dd>

                <dt className="col-sm-3">Fit Boxe</dt>
                <dd className="col-sm-9 mb-4">
                    Attività aerobica di intensità medio-alta che consiste nel poratare tecniche di braccia e gambe su un sacco o a vuoto
                    <br/> Prende spunto dal pugilato, dalla Kickboxing e dalla Muay Thai senza però entrare in contatto con l'avversario
                    <br/> Favorisce tonificazione, coordinazione, forza, circolazione sanguigna, migliora le capacità respiratorie aumentando la resistenza
                </dd>

            </dl>
        </div>
    )
}

export default FitnessInfoCorsi